import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=b111236a&scoped=true&"
import script from "./collapse.vue?vue&type=script&lang=js&"
export * from "./collapse.vue?vue&type=script&lang=js&"
import style0 from "./collapse.vue?vue&type=style&index=0&id=b111236a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b111236a",
  null
  
)

export default component.exports